// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"style__modalContainer___2NeAX","modal":"style__modal___1do_B","modalTitle":"style__modalTitle___KpuX6","modalText":"style__modalText___1Z1AQ","modalClose":"style__modalClose___30DUK","modalClose_memorial":"style__modalClose_memorial___AdHdj","confirmButtonInner":"style__confirmButtonInner___c7zjx"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-ui/components/confirm-modal/style.css
// module id = 1058
// module chunks = 0